// marquee/infinite scrolling texts
// // Store active GSAP instances
// function initMarquee(bar) {
//     const track = bar.querySelector(".ps-marquee-track");

//     if (bar._tween) bar._tween.kill();
//     track.querySelectorAll(".ps-item-clone").forEach(el => el.remove());

//     let originals = Array.from(track.querySelectorAll(".ps-item"));
    
//     // Reset widths
//     originals.forEach(i => i.style.width = "auto");

//     document.fonts.ready.then(() => requestAnimationFrame(() => {

//         // Freeze widths (final)
//         originals.forEach(i => {
//             i.dataset.w = i.offsetWidth;
//             i.style.width = i.offsetWidth + "px";
//         });

//         // Step 1 – Measure ORIGINAL SET width
//         const originalWidth = originals.reduce((sum, i) => sum + i.offsetWidth, 0);

//         // Step 2 – Clear clones
//         track.querySelectorAll(".ps-item-clone").forEach(el => el.remove());

//         // Step 3 – Duplicate EXACTLY ONE MORE SET
//         originals.forEach(item => {
//             const clone = item.cloneNode(true);
//             clone.classList.add("ps-item-clone");
//             clone.style.width = item.dataset.w + "px";
//             track.appendChild(clone);
//         });

//         // Step 4 – Now distance is EXACT and SAFE
//         const distance = originalWidth;

//         // Step 5 – Start tween
//         const speed = parseFloat(bar.dataset.speed) || 0.5;

//         bar._tween = gsap.to(track, {
//             x: -distance,
//             duration: distance / (speed * 100),
//             ease: "none",
//             repeat: -1,
//             modifiers: {
//                 x: gsap.utils.unitize(v => (parseFloat(v) % -distance))
//             }
//         });

//     }));
// }


// // INIT
// document.querySelectorAll(".ps-marquee-bar").forEach(bar => {
//     initMarquee(bar);

//     let t;
//     window.addEventListener("resize", () => {
//         clearTimeout(t);
//         t = setTimeout(() => initMarquee(bar), 300);
//     });
// });








// UPDATED horizontalLoop
// function horizontalLoop(items, config) {
//     items = gsap.utils.toArray(items);
//     config = config || {};

//     const tl = gsap.timeline({
//         repeat: config.repeat,
//         paused: config.paused,
//         defaults: { ease: "none" },
//         onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
//     });

//     const length = items.length;
//     const startX = items[0].offsetLeft;
//     const times = [];
//     const widths = [];
//     const xPercents = [];

//     const pixelsPerSecond = (config.speed || 1) * 100;
//     const fixedSpeed = config.autoSpeed ? pixelsPerSecond : null;

//     const snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1);

//     function populateWidths() {
//         items.forEach((el, i) => {
//             widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
//             xPercents[i] = snap(
//                 (parseFloat(gsap.getProperty(el, "x", "px")) / widths[i]) * 100 +
//                 gsap.getProperty(el, "xPercent")
//             );
//         });
//     }

//     populateWidths();
//     gsap.set(items, { xPercent: (i) => xPercents[i] });
//     gsap.set(items, { x: 0 });

//     function getTotalWidth() {
//         const last = items[length - 1];
//         return (
//             last.offsetLeft +
//             (xPercents[length - 1] / 100) * widths[length - 1] -
//             startX +
//             last.offsetWidth * gsap.getProperty(last, "scaleX") +
//             (parseFloat(config.paddingRight) || 0)
//         );
//     }

//     let totalWidth = getTotalWidth();

//     for (let i = 0; i < length; i++) {
//         const item = items[i];

//         const curX = (xPercents[i] / 100) * widths[i];
//         const distanceToStart = item.offsetLeft + curX - startX;
//         const distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");

//         // NEW: unified duration based on all items moving at the same speed
//         const duration1 = fixedSpeed ? widths[i] / fixedSpeed : distanceToLoop / pixelsPerSecond;
//         const duration2 = fixedSpeed ? widths[i] / fixedSpeed :
//             (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond;

//         tl.to(
//             item,
//             {
//                 xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
//                 duration: duration1
//             },
//             0
//         )
//             .fromTo(
//                 item,
//                 { xPercent: snap(((curX - distanceToLoop + totalWidth) / widths[i]) * 100) },
//                 {
//                     xPercent: xPercents[i],
//                     duration: duration2,
//                     immediateRender: false
//                 },
//                 duration1
//             );

//         times[i] = distanceToStart / pixelsPerSecond;
//     }

//     // Index helpers
//     let curIndex = 0;
//     function toIndex(index, vars) {
//         vars = vars || {};
//         if (Math.abs(index - curIndex) > length / 2) {
//             index += index > curIndex ? -length : length;
//         }
//         const newIndex = gsap.utils.wrap(0, length, index);
//         let time = times[newIndex];

//         if ((time > tl.time()) !== index > curIndex) {
//             vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
//             time += tl.duration() * (index > curIndex ? 1 : -1);
//         }

//         curIndex = newIndex;
//         vars.overwrite = true;
//         return tl.tweenTo(time, vars);
//     }

//     tl.next = (vars) => toIndex(curIndex + 1, vars);
//     tl.previous = (vars) => toIndex(curIndex - 1, vars);
//     tl.current = () => curIndex;
//     tl.toIndex = (index, vars) => toIndex(index, vars);
//     tl.updateIndex = () => (curIndex = Math.round(tl.progress() * (items.length - 1)));
//     tl.times = times;

//     tl.progress(1, true).progress(0, true);
//     if (config.reversed) {
//         tl.vars.onReverseComplete();
//         tl.reverse();
//     }

//     return tl;
// }


function initMarquee(bar) {
      const track = bar.querySelector(".ps-marquee-track");

      // Kill existing tween
      if (bar._tween) bar._tween.kill();

      // Remove clones
      track.querySelectorAll(".ps-item-clone").forEach(el => el.remove());

      // Get original items
      let originals = Array.from(track.querySelectorAll(".ps-item:not(.ps-item-clone)"));

      // Reset for measurement
      originals.forEach(i => i.style.width = "auto");

      document.fonts.ready.then(() =>
         requestAnimationFrame(() => {

            // Freeze widths
            originals.forEach(i => {
               i.dataset.w = i.offsetWidth;
               i.style.width = i.offsetWidth + "px";
            });

            // Measure original width
            const originalWidth = originals.reduce((sum, i) => sum + i.offsetWidth, 0);

            // Duplicate one more set
            originals.forEach(item => {
               const clone = item.cloneNode(true);
               clone.classList.add("ps-item-clone");
               clone.style.width = item.dataset.w + "px";
               track.appendChild(clone);
            });

            // Read speed + direction
            const speed = parseFloat(bar.dataset.speed) || 0.5;
            const direction = bar.dataset.direction === "right" ? 1 : -1;

            const distance = originalWidth;
            const duration = distance / (speed * 100);

            // SAFE loop math (your original)
            const loopWrap = v => (parseFloat(v) % -distance);

            // Set starting X for direction
            const startX = direction === 1 ? -distance : 0;
            const endX = direction === 1 ? 0 : -distance;

            // Apply fresh transform reset
            gsap.set(track, { x: startX });

            // GSAP tween
            bar._tween = gsap.to(track, {
               x: endX,
               duration: duration,
               ease: "none",
               repeat: -1,
               modifiers: {
                  x: gsap.utils.unitize(loopWrap)
               }
            });
         })
      );
   }


   // INIT — supports multiple marquees
   document.querySelectorAll(".ps-marquee-bar").forEach(bar => {
      initMarquee(bar);

      let t;
      window.addEventListener("resize", () => {
         clearTimeout(t);
         t = setTimeout(() => initMarquee(bar), 250);
      });
   });